import { Addon } from '@domain/addon';
import { getDefaultAddonNameTranslation } from '@utils/get-default-addon-name-translation/get-default-addon-name-translation';
import { TFunction } from 'i18next';

/**
 * Resolve an add-on preset's display name the way its row renders it: the custom `displayName`, else
 * the current-locale translation, else the type's default name. Single source of truth so a preset
 * list's search filter and the rendered label can't drift apart (B2B-1940).
 */
export const resolveAddonPresetName = (addon: Addon, t: TFunction, language: string): string => {
  const localizedName = addon.name?.[language] ?? '';
  const defaultNameKey = getDefaultAddonNameTranslation(addon.type);
  return addon.displayName || localizedName || (defaultNameKey ? t(defaultNameKey) : '');
};
